import {
   Box,
   Flex,
   useColorModeValue,
   Avatar,
   Text,
   Badge,
   HStack,
   IconButton,
   Button,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   useDisclosure,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Spacer,
   Divider,
   Grid,
   GridItem,
   Checkbox,
   Input,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon, CopyIcon, SettingsIcon, InfoIcon } from '@chakra-ui/icons';
import React, { useEffect, useState, useRef } from 'react';
import { CiMenuKebab, CiPhone } from 'react-icons/ci';
// import { getUser, deleteUser } from '../../../redux/actions/user';
import { useSelector, useDispatch } from 'react-redux';
// import ManageUserRoleForm from './ManageUserRoleForm';
import DeleteDialog from 'views/admin/masters/components/DeleteDialog';
// import AddUserModal from './ManageUserForm';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import moment from 'moment';
import {
   addPrintFormat,
   deletePrintFormat,
   getPrintFormat,
   getPrintFormatById,
} from '../../../../redux/actions/customizeprintings';
import { addSetupFormat, deleteSetupFormat } from '../../../../redux/actions/setupFormat';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { getDaybook } from '../../../../redux/actions/daybook';
import { functionNameOptions } from 'constants';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { useGlobal, useUser } from '../../../../contexts';
// import { useGlobal } from '../../../contexts';

export default function PrintSetting(props) {
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [isDeleteSetupDialogOpen, setDeleteSetupDialogOpen] = React.useState(false);
   const [isModalOpen, setIsModalOpen] = React.useState(false);
   const [newName, setNewName] = React.useState('');
   const [error, setError] = useState('');
   const printFormatData = useSelector((state) => state.customizeprintings?.single);
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const [row, setRow] = useState({
      id: null,
      functionName: '',
      companyId: '',
      daybookId: '',
      printId: '',
      isDefault: false,
   });
   const [viewSetupFormat, setViewSetupFormat] = useState({});
   const functionNames = functionNameOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   const [errors, setErrors] = useState({});
   const companyList = useSelector((state) => state.company.list || []);

   const dispatch = useDispatch();
   const list = useSelector((state) => state.customizeprintings?.list);
   const daybookData = useSelector((state) => state.daybook?.list);
   const user = useSelector((state) => state.user?.profile);

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;

   const {
      isOpen: isSetupFormatModalOpen,
      onOpen: onOpenSetupFormatModal,
      onClose: onCloseSetupFormatModal,
   } = useDisclosure();
   const {
      isOpen: isViewSetupFormatModalOpen,
      onOpen: onViewOpenSetupFormatModal,
      onClose: onViewCloseSetupFormatModal,
   } = useDisclosure();

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      // Clear the specific field error when user starts typing
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const clearFormData = () => {
      setRow({
         id: null,
         functionName: '',
         companyId: '',
         daybookId: '',
         printId: '',
         isDefault: false,
      });
      setErrors({});
   };

   const handleDuplicateClick = async (id) => {
      dispatch(getPrintFormatById(id)); // Get the data from API
      setIsModalOpen(true); // Open the popup/modal
   };

   const handleSaveDuplicate = () => {
      if (newName.trim() === '') {
         setError('Name is required.');
         return;
      }
      if (!printFormatData) return;
      const updatedName = newName.trim() !== '' ? newName : printFormatData.Name;
      const newEntry = {
         ...printFormatData,
         Name: updatedName, // Override the name
         id: undefined, // Ensure it's treated as new
         setupFormats: [],
      };
      delete newEntry.id;
      delete newEntry.dbName;
      delete newEntry.functionName;
      delete newEntry.css;
      delete newEntry.createdBy;
      delete newEntry.createdAt;
      delete newEntry.status;
      delete newEntry.updatedAt;
      delete newEntry.updatedBy;
      delete newEntry.setupFormats;

      dispatch(addPrintFormat(newEntry)); // Create new entry
      setIsModalOpen(false); // Close modal
      setNewName('');
   };

   useEffect(() => {
      const fetchData = async () => {
         try {
            await dispatch(getPrintFormat());
            // await dispatch(getDaybook());
            // await dispatch(getSetupFormat());
         } catch (error) {
            console.error('Error fetching data:', error);
         }
      };

      fetchData();
   }, [dispatch]);
   useEffect(() => {
      if (isSetupFormatModalOpen) {
         dispatch(getDaybook({ companyId: user?.loginhistory?.companyId, ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }) }));
      }
   }, [isSetupFormatModalOpen, dispatch, user]);

   const [isShareToCompanyModalOpen, setIsShareToCompanyModalOpen] = useState(false);

   const handleCloseShareToCompanyModal = () => {
      setIsShareToCompanyModalOpen(false);
   };

   const [selectedRowId, setSelectedRowId] = useState(null);
   const [selectedSetupRowId, setSelectedSetupRowId] = useState(null);
   const [data, setData] = useState([]);

   const handleDelete = async (member) => {
      setSelectedRowId(member.id);
      setDeleteDialogOpen(true);
   };
   const handleSetupDelete = async (id) => {
      setSelectedSetupRowId(id);
      setDeleteSetupDialogOpen(true);
   };

   const handleConfirmDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deletePrintFormat(selectedRowId));
            setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
            // await dispatch(getUser());
         } catch (err) {
            // console.error('Failed to delete series:', err);
         }
      }
   };
   const handleConfirmSetupDelete = async () => {
      if (selectedSetupRowId !== null) {
         try {
            await dispatch(deleteSetupFormat(selectedSetupRowId));
            // setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteSetupDialogOpen(false); // Close the dialog after deletion
            await dispatch(getPrintFormat());
         } catch (err) {
            // console.error('Failed to delete series:', err);
         }
      }
   };

   const scrollContainerRef = useRef(null);

   // Effect to enable smooth scrolling
   useEffect(() => {
      const handleScroll = (e) => {
         // Optional: Add any scroll behavior customization here
      };

      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
         scrollContainer.addEventListener('scroll', handleScroll);
      }

      return () => {
         if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', handleScroll);
         }
      };
   }, []);

   const handleSaveSetupFormat = async (row) => {
      try {
         await dispatch(addSetupFormat(row)); // if it's a Redux action
         await dispatch(getPrintFormat());
         clearFormData();
         onCloseSetupFormatModal(); // Close modal on success
      } catch (error) {
         console.error('Failed to save setup format:', error);
      }
   };

   return (
      <>
         <Flex
            minH={{ base: '85vh', lg: '85vh', xl: '85vh' }}
            maxH={{ base: '85vh', lg: '85vh', xl: '85vh' }}
            overflowY="auto">
            <Box p="10px" borderRadius="10px" alignItems="center" flexDirection="row">
               <Flex mt="30px" justifyItems={'center'} gap={4}>
                  <Link to="/admin/setting">
                     <Button mb="15px">
                        <IoMdArrowRoundBack size={18} />
                     </Button>
                  </Link>

                  <HStack mb={6} justify="space-between">
                     <Text fontSize="2xl" fontWeight="bold">
                        Print Settings
                     </Text>
                  </HStack>
               </Flex>

               <Text fontSize="xl" fontWeight="bold">
                  Company Print Settings
               </Text>
               <Flex
                  wrap="wrap"
                  gap={{ base: '3', md: '3', lg: '6' }}
                  mt={5}
                  justifyContent={{ md: 'center', xl: 'start' }}>
                  {list?.map((member, index) => {
                     if (member.dbName === null) {
                        return (
                           <Box
                              key={index}
                              bg={backgroundColor}
                              p={3}
                              borderRadius="md"
                              boxShadow="sm"
                              border="1px solid #e2e8f0"
                              w={{ sm: '100%', md: '330px', lg: '330px', xl: '360px' }}
                              textAlign="left"
                              position="relative">
                              <Flex align="center" gap={4} mb={3}>
                                 <Avatar name={member.name} src={member.avatar} size="md" />
                                 <Box>
                                    <Text fontWeight="bold" fontSize="md">
                                       {member.Name}
                                    </Text>
                                    <Flex align="center" gap={1}></Flex>
                                    {member.phone && (
                                       <Flex align="center" gap={1}>
                                          <CiPhone />
                                          <Text fontSize="sm" color="gray.600">
                                             {member.phone}
                                          </Text>
                                       </Flex>
                                    )}
                                 </Box>
                                 <Spacer />
                                 <Menu>
                                    <MenuButton as={IconButton} icon={<CiMenuKebab />} size="sm" variant="ghost" />
                                    <MenuList>
                                       <MenuItem
                                          icon={<CopyIcon />}
                                          isDisabled={member?.isAdmin}
                                          onClick={() => handleDuplicateClick(member.id)}>
                                          Duplicate
                                       </MenuItem>
                                       <MenuItem
                                          icon={<SettingsIcon />}
                                          onClick={() => {
                                             onOpenSetupFormatModal();
                                             setRow({ printId: member.id });
                                          }}
                                          isDisabled={member?.isAdmin}>
                                          Setup Format
                                       </MenuItem>
                                       <MenuItem
                                          icon={<InfoIcon />}
                                          onClick={() => {
                                             onViewOpenSetupFormatModal();
                                             setViewSetupFormat(member.setupFormats);
                                          }}
                                          isDisabled={member?.isAdmin}>
                                          View Setup Format
                                       </MenuItem>
                                    </MenuList>
                                 </Menu>
                              </Flex>
                              <Divider />
                              <Flex justify="space-between" mt={3} align="center">
                                 <Link to={`/admin/setting/print-settings/view/${member.id}`} className="button">
                                    <Badge
                                       bg={member?.isAdmin ? 'honeydew' : '#FFF0F5'}
                                       color={member?.isAdmin ? 'green.700' : 'gray.700'}
                                       borderRadius="full"
                                       px={2}
                                       py={1}>
                                       Preview
                                    </Badge>
                                 </Link>
                                 {member.createdAt && (
                                    <Text fontSize="xs" color="gray.500">
                                       {moment(member.createdAt).format('DD/MM/YYYY')}
                                    </Text>
                                 )}
                              </Flex>
                           </Box>
                        );
                     }
                     return null;
                  })}
               </Flex>
               {/* my Print Format */}
               <Divider mt={5} />
               <Text fontSize="xl" fontWeight="bold">
                  My Print Settings
               </Text>
               <Flex
                  wrap="wrap"
                  gap={{ base: '3', md: '3', lg: '6' }}
                  mt={5}
                  justifyContent={{ md: 'center', xl: 'start' }}>
                  {list?.map((member, index) => {
                     if (member.id !== user?.id && member.dbName !== null) {
                        return (
                           <Box
                              key={index}
                              bg={backgroundColor}
                              p={3}
                              borderRadius="md"
                              boxShadow="sm"
                              border="1px solid #e2e8f0"
                              w={{ sm: '100%', md: '330px', lg: '330px', xl: '360px' }}
                              textAlign="left"
                              position="relative">
                              <Flex align="center" gap={4} mb={3}>
                                 <Avatar name={member.name} src={member.avatar} size="md" />
                                 <Box>
                                    <Text fontWeight="bold" fontSize="md">
                                       {member.Name}
                                    </Text>
                                    <Flex align="center" gap={1}></Flex>
                                    {member.phone && (
                                       <Flex align="center" gap={1}>
                                          <CiPhone />
                                          <Text fontSize="sm" color="gray.600">
                                             {member.phone}
                                          </Text>
                                       </Flex>
                                    )}
                                 </Box>
                                 <Spacer />
                                 <Menu>
                                    <MenuButton as={IconButton} icon={<CiMenuKebab />} size="sm" variant="ghost" />
                                    <MenuList>
                                       <MenuItem
                                          icon={<CopyIcon />}
                                          isDisabled={member?.isAdmin}
                                          onClick={() => handleDuplicateClick(member.id)}>
                                          Duplicate
                                       </MenuItem>
                                       <Link to={`/admin/setting/print-settings/edit/${member.id}`} className="button">
                                          <MenuItem icon={<EditIcon />} isDisabled={member?.isAdmin}>
                                             Edit
                                          </MenuItem>
                                       </Link>
                                       <MenuItem
                                          icon={<DeleteIcon />}
                                          onClick={() => handleDelete(member)}
                                          isDisabled={member?.isAdmin}>
                                          Delete
                                       </MenuItem>
                                       <MenuItem
                                          icon={<SettingsIcon />}
                                          onClick={() => {
                                             onOpenSetupFormatModal();
                                             setRow({ printId: member.id });
                                          }}
                                          isDisabled={member?.isAdmin}>
                                          Setup Format
                                       </MenuItem>
                                       <MenuItem
                                          icon={<InfoIcon />}
                                          onClick={() => {
                                             onViewOpenSetupFormatModal();
                                             setViewSetupFormat(member.setupFormats);
                                          }}
                                          isDisabled={member?.isAdmin}>
                                          View Setup Format
                                       </MenuItem>
                                    </MenuList>
                                 </Menu>
                              </Flex>
                              <Divider />
                              <Flex justify="space-between" mt={3} align="center">
                                 <Link to={`/admin/setting/print-settings/view/${member.id}`} className="button">
                                    <Badge
                                       bg={member?.isAdmin ? 'honeydew' : '#FFF0F5'}
                                       color={member?.isAdmin ? 'green.700' : 'gray.700'}
                                       borderRadius="full"
                                       px={2}
                                       py={1}>
                                       Preview
                                    </Badge>
                                 </Link>

                                 {member.createdAt && (
                                    <Text fontSize="xs" color="gray.500">
                                       {moment(member.createdAt).format('DD/MM/YYYY')}
                                    </Text>
                                 )}
                              </Flex>
                           </Box>
                        );
                     }
                     return null;
                  })}
               </Flex>
            </Box>

            {/* <Link to="/admin/setting/print-settings/create" className="button">
               <Button
                  width="100px"
                  variant="darkBrand"
                  color="white"
                  fontSize="14px"
                  fontWeight="500"
                  borderRadius="full"
                  position="fixed"
                  bottom="20px"
                  right="40px"
                  p={6}
                  zIndex={100}>
                  Add new
               </Button>
            </Link> */}

            <Modal isOpen={isSetupFormatModalOpen} onClose={onCloseSetupFormatModal} isCentered size="xl">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>Setup Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     <Grid
                        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                        gap={2}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'functionName',
                              'Function Name',
                              functionNames,
                              {
                                 value: row.functionName,
                                 onChange: (value) => handleInputChange('functionName', value),
                              },
                              errors,
                              textColor,
                              false, // isRequired
                              'Select Function Name', // placeholder
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'daybookId',
                              'Daybook',
                              (() => {
                                 if (['Sales Invoice'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 5);
                                 } else if (['Sales Return', 'Credit Notes'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 6);
                                 } else if (['Purchase Invoices'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 11);
                                 } else if (['Purchase Returns', 'Debit Notes'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 12);
                                 } else if (['Cash Payments', 'Cash Receipts'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 13);
                                 } else if (['Bank Payment', 'Bank Receipt'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 14);
                                 } else if (['Journal Voucher'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 18);
                                 } else if (['Inventory Issues'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 19);
                                 } else if (['Inventory Receipts'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 20);
                                 } else {
                                    return daybookData;
                                 }
                              })(),
                              {
                                 value: row.daybookId,
                                 onChange: (value) => handleInputChange('daybookId', value),
                              },
                              errors,
                              textColor,
                              false, // isRequired
                              'Select Daybook', // placeholder
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'companyId',
                              'Company',
                              companyList,
                              {
                                 value: row.companyId,
                                 onChange: (value) => handleInputChange('companyId', value),
                                 showCustomNoOptions: true,
                              },
                              errors,
                              textColor,
                              false, // isRequired
                              'Select Compony', // placeholder
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {DynamicInput(
                              'printerName',
                              'Printer Name',
                              {
                                 value: row.printerName,
                                 onChange: (e) => handleInputChange('printerName', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                        <Checkbox
                           isChecked={row.isDefault}
                           onChange={(e) => handleInputChange('isDefault', e.target.checked)}>
                           Set Default
                        </Checkbox>
                     </Grid>
                  </ModalBody>
                  <ModalFooter>
                     <Button colorScheme="gray" mr={3} onClick={onCloseSetupFormatModal}>
                        Cancel
                     </Button>
                     <Button colorScheme="green" variant="solid" onClick={() => handleSaveSetupFormat(row)}>
                        Save Changes
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <Modal
               isOpen={isViewSetupFormatModalOpen}
               onClose={() => {
                  onViewCloseSetupFormatModal();
                  setViewSetupFormat({});
               }}
               size="xl">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>View Setup Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     {' '}
                     {Array.isArray(viewSetupFormat) && viewSetupFormat.length > 0 ? (
                        viewSetupFormat.map((format, index) => (
                           <Box
                              key={index}
                              border="1px solid #e2e8f0"
                              p={4}
                              borderRadius="md"
                              mb={3}
                              position="relative">
                              <Flex justify="space-between" align="start">
                                 <Box>
                                    <Text>
                                       <strong>Print Invoice Name:</strong> {format.name}
                                    </Text>
                                    <Text>
                                       <strong>Function Name:</strong> {format.functionname}
                                    </Text>
                                    <Text>
                                       <strong>Status:</strong> {format.status ? 'Active' : 'Inactive'}
                                    </Text>
                                    <Text>
                                       <strong>Company:</strong> {format.companyName}
                                    </Text>
                                    <Text>
                                       <strong>Daybook:</strong> {format.daybookName}
                                    </Text>
                                    <Text>
                                       <strong>Created At:</strong> {moment(format.createdat).format('DD/MM/YYYY')}
                                    </Text>
                                    {format.updatedat && (
                                       <Text>
                                          <strong>Updated At:</strong> {moment(format.updatedat).format('DD/MM/YYYY')}
                                       </Text>
                                    )}
                                 </Box>
                                 <IconButton
                                    icon={<DeleteIcon />}
                                    aria-label="Delete format"
                                    size="sm"
                                    colorScheme="red"
                                    onClick={() => handleSetupDelete(format.id)} // Replace with your delete function
                                 />
                              </Flex>
                              <Divider mt={2} />
                           </Box>
                        ))
                     ) : (
                        <Text>No setup formats available.</Text>
                     )}
                  </ModalBody>
                  <ModalFooter>
                     <Button
                        colorScheme="blue"
                        mr={3}
                        onClick={() => {
                           onViewCloseSetupFormatModal();
                           setViewSetupFormat({});
                        }}>
                        Close
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>Duplicate Print Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     <Input
                        placeholder="Enter new name"
                        value={newName}
                        onChange={(e) => {
                           setNewName(e.target.value);
                           if (e.target.value.trim() !== '') setError('');
                        }}
                        isInvalid={!!error}
                     />
                     {error && (
                        <Text color="red.500" mt={2}>
                           {error}
                        </Text>
                     )}
                  </ModalBody>
                  <ModalFooter>
                     <Button colorScheme="blue" onClick={handleSaveDuplicate}>
                        Save
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleConfirmDelete}
               title="Print Format"
            />
            <DeleteDialog
               isDeleteDialogOpen={isDeleteSetupDialogOpen}
               setDeleteDialogOpen={setDeleteSetupDialogOpen}
               handleDelete={handleConfirmSetupDelete}
               title="Setup Format"
            />
         </Flex>
      </>
   );
}
